import React from 'react';
import { useTranslate } from '@src/core/hooks';
import { Wrapper, Label, PriceLine, PriceValue, PriceSuffix } from './styles';
import useCurrencyFormat from '@src/hooks/useCurrencyFormat';

type Props = {
  totalCents: number;
};

const ReservationTotal: React.FC<Props> = ({ totalCents }) => {
  const { i18n } = useTranslate();
  const { formatCents } = useCurrencyFormat();

  return (
    <Wrapper>
      <Label>{i18n('product_booking_total_label')}</Label>
      <PriceLine>
        <PriceValue>{formatCents(totalCents)}</PriceValue>
        <PriceSuffix>{i18n('product_booking_total_at_sight_suffix')}</PriceSuffix>
      </PriceLine>
    </Wrapper>
  );
};

export default ReservationTotal;
